module.exports = __webpack_public_path__ + "img/library_research.90a85ca0.jpg";